import React from "react";
import PracticeAreaLayout from "../components/PracticeAreaLayout";
import SeoMetaTags from "../components/SeoMetaTags";

/**
 * RealEstateLaw Component
 *
 * Page component for the Real Estate Law practice area
 */
function RealEstateLaw() {
  return (
    <>
      <SeoMetaTags 
        slug="real-estate-law"
        defaultTitle="Real Estate Law - Sentry Law | Calgary Legal Advice"
        defaultDescription="Expert legal assistance in real estate transactions in Calgary, including buying, selling, and refinancing properties. Contact us for professional legal services."
      />
      
      <PracticeAreaLayout
        title="REAL ESTATE LAW"
        content="LawyerG wants to help you with the biggest purchase of your life — your home. We know anything to do with buying or selling your home is a big decision. That's why we want to help. We have the experience and expertise to guide you through the process. We'll review all documents with you and make sure property taxes are up-to-date, and that no claims are listed against the property. Call us today if you're considering buying, selling or refinancing."
        image="/images/real-estate-law.jpg" // Replace with appropriate legal image
        imageAlt="Real Estate Law Services"
        buttonText="CORPORATE & COMMERCIAL"
        buttonLink="/corporate-and-commercial"
        breadcrumbLabel="Real Estate Law"
        section="practices"
      />
    </>
  );
}

export default RealEstateLaw;
